export default __webpack_public_path__ + "static/media/D_wdt_c_cap_1.ac81dc0f.mp3";